<template>
    <div class="mb-2">
        <div class="medium-content mb-3">
            <h2 class="text-center">Cultura Chico Rei</h2>
            <div>
                <p style="text-align: justify">
                    Nossos valores são focados nas pessoas que vivenciam a jornada Chico Rei.
                    Conheça um pouco mais do que acreditamos e praticamos no nosso dia a dia:
                </p>
            </div>
        </div>
        <div class="d-flex flex-wrap flex-justify-center hidden-md-down">
            <div v-for="topic in topics" class="flip-card text-center">
                <div class="flip-card-inner rounded">
                    <div class="d-flex flip-card-front flex-align-center">
                        <h2 class="front-text">{{ topic.header }}</h2>
                    </div>
                    <div class="d-flex flip-card-back">
                        <p class="back-text">{{ topic.description }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="hidden-md-up">
            <div
                class="horizontal-list horizontal-list-2 no-scrollbar"
                @scroll="scrollEvent = $event"
            >
                <div v-for="topic in topics" class="list-card">
                    <div class="list-card-title">
                        <p style="margin: 0">{{ topic.header }}</p>
                    </div>
                    <div class="list-card-textbox">
                        <img
                            :src="`${$scope.CDN_IMAGES}/images/site/2021/brand/pattern.svg?auto=compress,format&q=65`"
                            class="list-card-pattern-bg"
                        />
                        <p class="list-card-text">{{ topic.description }}</p>
                    </div>
                </div>
            </div>
            <HorizontalScrollbar :scroll-event="scrollEvent" />
        </div>
    </div>
</template>

<script>
    import HorizontalScrollbar from '../common/container/HorizontalScrollbar';

    export default {
        name: 'CultureSection',

        components: { HorizontalScrollbar },

        data() {
            return {
                scrollEvent: null,
                topics: [
                    {
                        header: 'Vontade de mudar o mundo',
                        description:
                            'Resume nosso propósito, apoiado em três pilares - ser meio de caminho para impacto social positivo, ser forma de expressão para o nosso cliente e ser a ressignificação da relação com trabalho para o nosso time.',
                    },
                    {
                        header: 'Inquietude criativa',
                        description:
                            'Buscamos ser disruptivos em tudo o que fazemos, buscando sempre a melhoria contínua e entendendo que o erro é parte do processo da busca por inovação.',
                    },
                    {
                        header: 'Somos um grande time',
                        description:
                            'Investimos na diversidade como base para a construção de uma empresa saudável e acreditamos que a coletividade supera o individual, criando um time onde cada um é fã do outro.',
                    },
                    {
                        header: 'Vestimos a camiseta',
                        description:
                            'A paixão pelo nosso trabalho reflete diretamente no que é criado, com isso sangue nos olhos é essencial. Botamos a mão na massa pra valer e nunca fugimos de responsabilidades.',
                    },
                    {
                        header: 'Falamos de igual para igual',
                        description:
                            'Aqui todos têm abertura para contribuir, por isso deixamos as ideias soltas para correrem sem barreiras em nosso espaço.',
                    },
                    {
                        header: 'De Minas para o mundo',
                        description:
                            'Temos orgulho de nossas raízes mineiras e fazemos questão de espalhar isso por aí. Construímos uma marca forte e com linguagem bem definida com o objetivo de explorar esse nosso mundão.',
                    },
                ],
            };
        },
    };
</script>
